import { render, staticRenderFns } from "./RelocationServices.vue?vue&type=template&id=62d3fe59&"
import script from "./RelocationServices.vue?vue&type=script&lang=js&"
export * from "./RelocationServices.vue?vue&type=script&lang=js&"
import style0 from "./RelocationServices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports